import {getLanguage, getQueryParameterByName} from "../../utils";

export class API {
  static baseUrl: string = "https://ivans-lystfiskeri.leicht-thruesen.com/api/"

  static book = async (booking: any) => {
    const bookingUrl = `${API.baseUrl}booking`;

    return new Promise((resolve, reject) => {
      $.ajax({
        url: bookingUrl,
        type: 'POST',
        data: {data: JSON.stringify(booking)},
        success: function (result) {
          resolve(result);
        },
        error: function (e) {
          reject(e);
        }
      });
    })
  }

  static getEvents = async (endMonth: string, endYear: string) => {
    const eventsUrl = `${API.baseUrl}calendarEvent?language=${getLanguage()}&year=${endYear}&month=${endMonth}`;

    try {
      return await fetch(eventsUrl).then((result) => {
        return result.json();
      })
    } catch (e) {

    }
  }

  static getWebShopContent = async () => {
    const webShopUrl = `${API.baseUrl}product`;

    try {
      return await fetch(webShopUrl).then((result) => {
        return result.json();
      })
    } catch (e) {

    }
  }

  static getSingleEvent = async () => {
    const language = getQueryParameterByName("lang");
    const singleEventId = getQueryParameterByName("id");
    const url = `${API.baseUrl}calendarEvent?language=${language}&element_id=${singleEventId}`

    try {
      return await fetch(url).then((result) => {
        return result.json();
      })
    } catch (e) {

    }
  }
}
